<template>
  <div id="orderList">
    <div style="height: 55px;background-color: #fff;"></div>
    <ul class="oul" v-if="orderList.length">
      <li class="item" v-for="(order, index) in orderList" :key="index">
        <div class="top">
          <div class="left">
            <span class="order">订单号：</span>
            <span class="number">{{order.orderId}}</span>
            <span style="margin: 0 15px;">|</span>
            <span class="time">{{order.createTime | formatTime}}</span>
          </div>
          <div class="right">{{getStatus(order.orderStatus)}}</div>
        </div>
        <div class="content" v-for="(item, i) in order.details" :key="i">
          <p>商品清单</p>
          <img :src="item.productImage || 'http://k2.jsqq.net/uploads/allimg/1707/17_170729153742_4.jpg'" alt="">
          <p class="ml93">{{item.specifications}}/超高亮/{{item.productName}}</p>
          <p class="ml93">x{{item.num}}</p>
        </div>
        <div class="bottom">
          <div class="slider">
            <span>订单金额</span>
            <span style="margin-left: 50px;">￥{{order.orderPrice}}</span>
          </div>
          <div class="other" v-if="order.orderStatus === 'WAIT_PAY'">
            <button class="cancel" @click="cancelOrder(order)">取消订单</button>
            <button class="pay" @click="goPay(order)">立即支付</button>
          </div>
        </div>
      </li>
      <li class="more_box" v-if="MoreShow" @click="getOrderList">
        <div class="more">加载更多</div>
      </li>
    </ul>
    <div v-else style="height: 597px;margin-top: 100px;font-size: 20px;">
      <div style="background-color:#fff;width: 1201px;height: 479px;margin: 0 auto;padding-top: 150px;box-sizing: border-box">
        <img src="../../assets/image/order-normal.png" alt="" class="normal">
        <p style="font-family: 'SourceHanSansCN-Normal';margin-top: 33px;">你还没有订单哦，快去逛逛吧~</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'orderList',
  data () {
    return {
      orderList: [],
      page: 0,
      pageSize: 5,
      MoreShow: false
    }
  },
  computed: {
  },
  methods: {
    getOrderList () {
      let that = this
      that.page++
      that.axios.post('/order/list', {
        userId: that.$root.getUserId(),
        page: that.page,
        pageSize: that.pageSize
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          let res = response.data.value
          if (that.page === 1) {
            that.orderList = res.dataLst
          } else {
            that.orderList = that.orderList.concat(res.dataLst)
          }
          if (res.dataLst.length >= that.pageSize) {
            that.MoreShow = true
          } else {
            that.MoreShow = false
          }
          console.log(456789)
          console.log(that.orderList)
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    getStatus (status) {
      let state = ''
      if (status === 'WAIT_PAY') {
        state = '待支付'
      } else if (status === 'FINISH') {
        state = '已完成'
      } else if (status === 'CANCEL') {
        state = '已取消'
      }
      return state
    },
    goPay (order) {
      let that = this
      that.axios.post('/order/getPayUrl', {
        orderId: order.orderId
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          that.$router.push({name: 'payment', params: {codeUrl: response.data.value, orderId: order.orderId}})
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    },
    cancelOrder (order) {
      let that = this
      that.axios.post('/order/cancel', {
        orderId: order.orderId
      }, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        emulateJSON: true
      }).then(function (response) {
        if (response.data.status === 0) {
          that.$store.commit('setToastMsg', '取消成功')
        } else {
          that.$store.commit('setToastMsg', response.data.msg)
        }
      }).catch(function (response) {
        that.$store.commit('setToastMsg', '网络错误')
      })
    }
  },
  created () {
    this.getOrderList()
  }

}
</script>

<style scoped>
  #orderList{
    background-color: #f0f0f0;
    height: 100%;
  }
  .oul{
    width: 1201px;
    margin: 59px auto;
    list-style: none;
  }
  .item{
    /*height: 307px;*/
    margin-top: 21px;
    padding: 51px 41px 0 42px;
    background-color: #fff;
    box-sizing: border-box;
  }
  .item .top{
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #cccccc;
    padding-bottom: 25px;
  }
  .item .top .left>span{
    font-family: "SourceHanSansCN-Normal";
  }
  .item .top .left>span.order{
    font-size: 16px;
  }
  .item .top .left>span.number{
    font-size: 16px;
    color: #21a26e;
  }
  .item .top .left>span.time{
    font-size: 14px;
    color: #3f3f3f;
  }
  .item .top .right{
    font-size: 18px;
    font-family: "SourceHanSansCN-Normal";
  }
  .item .content{
    text-align: left;
    display: flex;
    align-items: center;
    padding: 15px 0;
    border-bottom: 1px solid #ccc;
    box-sizing: border-box;
  }
  .item .content>p{
    color: #333;
    font-size: 16px;
    font-family: "SourceHanSansCN-Normal";
  }
  .item .content img{
    width: 100px;
    height: 100px;
    margin-left: 50px;
  }
  .ml93{
    margin-left: 93px;
  }
  .bottom{
    height: 100px;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .bottom .slider span{
    text-align: left;
    font-size: 16px;
    color: #333;
    font-family: "SourceHanSansCN-Normal";
  }
  .bottom .other button{
    width: 116px;
    height: 37px;
    text-align: center;
    line-height: 37px;
    border-radius: 2px;
    font-size: 16px;
    font-family: "SourceHanSansCN-Normal";
  }
  .bottom .other button.cancel{
    color: #333333;
    background-color: #f4f4f4;
    margin-right: 10px;
    cursor: pointer;
  }
  .bottom .other button.pay{
    color: #FFFFFF;
    background-color: #05b570;
    cursor: pointer;
  }
  /*-----------加载更多样式--------*/
  .more_box{
    /*margin-top: 21px;*/
    border-top: 1px solid #cccccc;
    padding: 51px 41px 51px 42px;
    background-color: #fff;
    box-sizing: border-box;
  }
  .more {
    font-size: 20px;
    line-height: 50px;
    margin: 0 auto;
    width: 280px;
    height: 50px;
    background-color: #05B570;
    color: #FFFFFF;
    cursor: pointer;
  }
  .normal{
    width: 54px;
    height: 59px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shoppingCar/orderList.vue